module.exports = __webpack_public_path__ + "img/head3.de6ddc23.png";